import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=2ec0e04c&scoped=true"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"
import style0 from "./wizard.vue?vue&type=style&index=0&id=2ec0e04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0e04c",
  null
  
)

export default component.exports